import React, { useEffect, useState } from "react";
import {
	Button,
	Modal,
	Upload,
	message,
	Icon,
	Popconfirm,
	Spin,
	Alert,
} from "antd";
import { useRouteMatch } from "react-router";
import { useDispatch } from "react-redux";

import getAddressMeters from "../../store/thunks/getAddressMeters";
import saveReport from "../../store/thunks/saveReport";
import fileFormat from "../../constants/fileFormat";
import checkAreThereAnyMeters from "../../requests/checkAreThereAnyMeters";
import getAddresses from "../../store/thunks/getAddresses";
import "./UploadReport.scss";

const UploadReport = () => {
	const dispatch = useDispatch();
	const {
		params: { houseId },
	} = useRouteMatch("/Meters/address/:houseId") || { params: {} };
	const [modalIsOpened, setModalOpened] = useState(false);
	const [file, setFile] = useState(null);
	const [fileList, setFileList] = useState([]);
	const [thereAreMetersInCompany, setThereAreMetersInCompany] = useState(false);
	const [loading, setLoading] = useState(false);
	const [addressesLoading, setAddressesLoading] = useState(true);

	useEffect(() => {
		(async () => {
			if (modalIsOpened) {
				setAddressesLoading(true);
				setThereAreMetersInCompany(await checkAreThereAnyMeters());
				setAddressesLoading(false);
			}
		})();
	}, [modalIsOpened]);

	const onOk = async () => {
		setLoading(true);
		const response = await saveReport(file);
		setLoading(false);
		let closeMessage;
		if (response.type === "success") {
			message.success(response.text);
		} else {
			closeMessage = message[response.type](
				<div
					style={{
						maxWidth: "400px",
						display: "flex",
						flexDirection: "column",
					}}
				>
					<span style={{ marginBottom: "5px" }}>{response.text}</span>
					<Button
						onClick={() => {
							closeMessage();
						}}
					>
						Ок
					</Button>
				</div>,
				0
			);
		}
		setModalOpened(false);
		setFile();
		setFileList();
		setThereAreMetersInCompany();
		houseId && dispatch(getAddressMeters(houseId));
		dispatch(getAddresses({}));
	};

	const onCancel = () => {
		if (!loading) {
			setModalOpened(false);
			setFile();
			setFileList();
			setThereAreMetersInCompany();
		}
	};

	const sendButton =
		!addressesLoading && thereAreMetersInCompany ? (
			<Popconfirm
				title={
					<>
						Показания из загружаемого файла заменят <br />
						существующие показания по счетчикам
					</>
				}
				okText="Ок"
				onConfirm={onOk}
			>
				<Button
					style={{ marginLeft: addressesLoading || !file ? "8px" : "" }}
					disabled={addressesLoading || !file}
					key="submit"
					type="primary"
					loading={loading}
				>
					Отправить
				</Button>
			</Popconfirm>
		) : (
			<Button
				disabled={addressesLoading || !file}
				key="submit"
				type="primary"
				loading={loading}
				onClick={onOk}
			>
				Отправить
			</Button>
		);
	return (
		<>
			<Button
				className="file-button"
				icon="plus"
				onClick={() => {
					setModalOpened(true);
				}}
			>
				Загрузить показания
			</Button>
			{modalIsOpened && (
				<Modal
					style={{ width: "600px" }}
					visible={modalIsOpened}
					title="Загрузка показаний ОДПУ"
					onOk={onOk}
					onCancel={onCancel}
					footer={[
						<Button key="back" onClick={onCancel}>
							Назад
						</Button>,
						sendButton,
					]}
					className="file-add"
				>
					<Spin spinning={addressesLoading}>
						<Alert
							type="warning"
							showIcon={true}
							message="На демонтированные счетчики новые показания не внесутся"
							style={{ marginBottom: '16px' }}
						/>
						<Upload.Dragger
							beforeUpload={(file) => {
								if (
									fileFormat.includes(file.type) ||
									file.name.split(".").pop() === "xlsx" ||
									file.name.split(".").pop() === "csv"
								) {
									setFile(file);
									return false;
								} else {
									message.error("Подходят файлы расширения XLSX или CSV");
								}
							}}
							fileList={fileList}
							onChange={(info) => {
								let fileList = [...info.fileList];
								fileList = fileList.slice(-1);
								setFileList(fileList);
							}}
						>
							<p className="file-add-title">
								<Icon type="file-add" className="file-add-icon" />
								<span>перетащите файлы сюда или нажмите, чтобы выбрать</span>
							</p>
						</Upload.Dragger>
						<p className="file-add-description">
							Файл должен быть расширения XLSX или CSV.
						</p>
					</Spin>
				</Modal>
			)}
		</>
	);
};

export default UploadReport;
